import "bootstrap/dist/css/bootstrap.min.css";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "bootstrap";
import "@popperjs/core";
import './services/interceptors'
import '@fortawesome/fontawesome-free/css/all.min.css';

const app = createApp(App);

app.use(router);
app.mount("#app");

import "bootstrap/dist/js/bootstrap.min";
